<template>
    <div class="timetracker-filter">
        <Card dis-hover>
            <Row :gutter="20">
                <Col :xs="2" :sm="4" :md="6" :lg="10" class="d-flex-center">
                    <span style="margin-right: 20px">Employee</span>
                    <Select
                        v-model="selectedMember"
                        :value="$route.query.user"
                        filterable
                        clearable
                        @on-change="showChart"
                    >
                        <Option v-for="employee in employees" :key="employee._id._id" :value="employee._id._id">
                            {{ employee._id.name }}
                            <Tag color="default">To: {{ employee.total }}</Tag>
                            <Tag color="blue">VL: {{ employee.vl }} </Tag>
                            <Tag color="purple">SL: {{ employee.sl }} </Tag>
                        </Option>
                    </Select>
                </Col>
            </Row>
            <EmployeeLeaveHistory ref="employeeLeaveHistory" />
        </Card>
    </div>
</template>

<script>
import { getAllEmployeeLeaves } from '@/components/Admin/LeaveSummary/services/leave-summary.service.ts';
import EmployeeLeaveHistory from '@/components/Admin/LeaveSummary/EmployeeLeaveHistory.vue';

export default {
    components: { EmployeeLeaveHistory },
    props: {
        projectMembersList: {
            type: Array,
            default: () => [],
        },
        projectsList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            employees: [],
        };
    },
    created() {
        if (this.$route.query.user) {
            this.$emit('filter', this.selectedMember, this.selectedProject);
        }
    },
    methods: {
        async populateEmployeeList() {
            const { data } = await getAllEmployeeLeaves();
            this.employees = data;
            console.log('employee list with leaves');
        },
        async showChart(employee) {
            await this.$refs.employeeLeaveHistory.showHistory(employee);
        },
    },
    async mounted() {
        await this.populateEmployeeList();
    },
};
</script>
<style lang="scss">
@media screen and (max-width: 767px) {
    .timetracker-filter {
        .ivu-row {
            display: block;

            .ivu-col {
                max-width: 100%;
            }
            .ivu-col-span-xs-2 {
                margin: 5px 0;
            }
            .filter-btn button {
                width: 100%;
            }
        }
    }
}
</style>
